import { render, staticRenderFns } from "./CellHouseClass.vue?vue&type=template&id=24cf1109"
import script from "./CellHouseClass.vue?vue&type=script&lang=js"
export * from "./CellHouseClass.vue?vue&type=script&lang=js"
import style0 from "./CellHouseClass.vue?vue&type=style&index=0&id=24cf1109&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports